import {
  DragDrop,
  Uppy,
  AwsS3,
  ProgressBar,
} from "https://releases.transloadit.com/uppy/v4.17.0/uppy.min.mjs";

const asyncForEach = async function (array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
};

export default {
  create(target, options = {}) {
    const progress = document.createElement("div");
    target.after(progress);

    let statusBarTimeout = null;

    const statusBar = document.createElement("div");
    statusBar.classList.add("uppy-status-bar");
    target.after(statusBar);

    const uppyInstance = new Uppy({
      autoProceed: true,
      restrictions: {
        maxNumberOfFiles: options.maxNumberOfFiles || 1,
        maxFileSize: options.maxFileSize,
        allowedFileTypes: options.allowedFileTypes,
      },
    })
      .use(DragDrop, { debug: true, target: target, note: options.note })
      .use(AwsS3, {
        endpoint: "/",
        shouldUseMultipart: true,
      })
      .use(ProgressBar, { target: progress });

    uppyInstance.on("complete", async (result) => {
      await asyncForEach(result.successful, async (file) => {
        const uploadedFileData = {
          id: file.s3Multipart["key"].match(/^cache\/(.+)/)[1], // object key without prefix
          storage: "cache",
          metadata: {
            size: file.size,
            filename: file.name,
            mime_type: file.type,
          },
        };
        if (typeof options.eachFileCallback === "function") {
          options.eachFileCallback(file, uploadedFileData);
        }
      });
      if (typeof options.completeCallback === "function") {
        options.completeCallback(result);
      }
    });

    uppyInstance.on("restriction-failed", async (file, error) => {
      console.warn("restriction-failed", error);
      statusBar.textContent = error.message;
      statusBar.style.display = "flex";
      clearTimeout(statusBarTimeout);
      statusBarTimeout = setTimeout(() => {
        statusBar.textContent = "";
        statusBar.style.display = "none";
      }, 3000);
    });

    return uppyInstance;
  },
};
